export default function buildGemfile () {
  return `source "https://rubygems.org"

gem "foobara", ">= 0.2.7"
gem "foobara-remote-imports"
gem "foobara-sh-cli-connector"
gem "foobara-load-dotenv"`
}
